<script setup lang="ts">
/**
 * BreakdownPopover — title + divider + key-value rows. Generic shape for any
 * "summary breakdown" content (fees, taxes, totals, allocation, …).
 */
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'

export interface BreakdownRow {
  label: string
  value: string
}

interface Props {
  title?: string
  rows: BreakdownRow[]
}

withDefaults(defineProps<Props>(), {
  title: 'Breakdown',
})
</script>

<template>
  <Box direction="col" gap="3" class="breakdown-popover">
    <Text type="body" weight="semibold" class="breakdown-popover__title">{{ title }}</Text>
    <Box class="breakdown-popover__divider" />
    <Box direction="col" gap="3">
      <Box
        v-for="row in rows"
        :key="row.label"
        flex
        align="center"
        justify="between"
        gap="3"
      >
        <Text type="body-sm" color="muted">{{ row.label }}</Text>
        <Text type="body-sm" weight="semibold" class="breakdown-popover__value">
          {{ row.value }}
        </Text>
      </Box>
    </Box>
  </Box>
</template>

<style scoped>
.breakdown-popover {
  width: 320px;
  padding: 18px 20px;
}

.breakdown-popover__title {
  font-size: 15px;
  line-height: 1.4;
}

.breakdown-popover__divider {
  height: 1px;
  background: var(--p-content-border-color);
  margin: -4px 0;
}

.breakdown-popover__value {
  white-space: nowrap;
}
</style>
